import { Component, Input, OnInit } from '@angular/core';
import {Player} from '@shared/models/player';
import {Trainer} from '@shared/models/trainer';
import {ImageService} from '@utils/services/image/image.service';

@Component({
  selector: 'app-player-card',
  templateUrl: './player-card.component.html',
  styleUrls: ['./player-card.component.scss']
})
export class PlayerCardComponent implements OnInit {

  @Input() player: Player|Trainer;
  public logoUrl: string = null;
  public firstname: string = null;
  public lastname: string = null;
  public trainername: string = null;
  public isTrainer = false;
  public position: string = null;
  public status: string = '';
  public number: number = null;
  public skillsLabScore: number;
  public skillsLabLogo = ImageService.StaticImages.Logo.SkillsLabLogo;
  public skillsLabLink = 'https://skills-lab.com';

  ngOnInit() {
    if (this.player != null) {
      this.logoUrl = this.player.getImageUrlOfSize('medium');

      if (this.player instanceof Player) {
        const player = this.player as Player;
        this.firstname = player.firstname;
        this.lastname = player.lastname;
        this.position = player.position;
        this.status = player.getPlayerStatusString();
        this.number = player.number;
        if (this.player.scores?.skills_lab) {
          this.skillsLabScore = this.player.scores.skills_lab.total;
        }
      } else if (this.player instanceof Trainer) {
        const trainer = this.player as Trainer;
        this.trainername = trainer.trainername;
        this.firstname = trainer.firstname;
        this.lastname = trainer.lastname;
        this.position = trainer.position;

        this.isTrainer = true;
      }
    }
  }

}
